import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface ImageSlideDeckProps {
  slides: { imageUrl: string; caption?: string }[];
}

const ImageSlideDeck: React.FC<ImageSlideDeckProps> = ({ slides }) => {
  const [index, setIndex] = useState(0);
  if (slides.length === 0) return null;
  const slide = slides[index];

  const goTo = (next: number) => {
    if (next < 0 || next >= slides.length) return;
    setIndex(next);
  };

  return (
    <div
      className="lesson-slides"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowRight") goTo(index + 1);
        if (e.key === "ArrowLeft") goTo(index - 1);
      }}
      aria-roledescription="carousel"
      aria-label="Slide deck"
    >
      <div className="lesson-slides__card lesson-slides__card--image" aria-live="polite">
        <p className="lesson-slides__count">
          Slide {index + 1} of {slides.length}
        </p>
        <img src={slide.imageUrl} alt={slide.caption || ""} />
        {slide.caption && <p className="lesson-slides__caption">{slide.caption}</p>}
      </div>

      <div className="lesson-slides__controls">
        <button type="button" onClick={() => goTo(index - 1)} disabled={index === 0} aria-label="Previous slide">
          <ChevronLeft aria-hidden="true" size={20} />
        </button>
        <div className="lesson-slides__dots">
          {slides.map((s, dotIndex) => (
            <button
              key={s.imageUrl + dotIndex}
              type="button"
              className={dotIndex === index ? "is-active" : ""}
              aria-label={`Go to slide ${dotIndex + 1}`}
              aria-current={dotIndex === index}
              onClick={() => goTo(dotIndex)}
            />
          ))}
        </div>
        <button
          type="button"
          onClick={() => goTo(index + 1)}
          disabled={index === slides.length - 1}
          aria-label="Next slide"
        >
          <ChevronRight aria-hidden="true" size={20} />
        </button>
      </div>
    </div>
  );
};

export default ImageSlideDeck;
